import React, { FC } from 'react'
import styled from 'styled-components'

import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { Logo } from './Logo'
import { lng } from '@ads/front-core/locales'

export const Top: FC = () => (
  <Wrapper>
    <Content>
      <TopImage>
        <Logo />
      </TopImage>
      <TopText>{lng('lppartners:top.text1')}</TopText>
      <CenterText>{lng('lppartners:top.text2')}</CenterText>
      <Button
        onClick={() =>
          document
            .getElementById('pform')
            .scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      >
        {lng('lppartners:top.button')}
      </Button>
    </Content>
  </Wrapper>
)

const Wrapper = styled.div`
  background: #262a44;
`

const Content = styled.div`
  font-family: Poppins;
  max-width: 1348px;
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 53px 0 88px 0;
  background: url(/img/partners/1.jpg) no-repeat center center;
  background-size: cover;
  color: #fff;

  @media (max-width: ${breakpoints.MOBILE}) {
    padding: 63px 32px 128px 32px;
  }
`

const TopImage = styled.div`
  @media (max-width: ${breakpoints.MOBILE}) {
    svg {
      height: 68px;
    }
  }
`

const Button = styled.div`
  background: #ec1c24;
  border-radius: 50px;
  padding: 14px 36px;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  margin-top: 80px;
  color: #fff;
  border: 0;
  cursor: pointer;
  min-width: 271px;
  text-align: center;

  @media (max-width: ${breakpoints.MOBILE}) {
    margin-top: 80px;
    width: 100%;
  }
`

const TopText = styled.p`
  font-size: 45px;
  font-weight: 600;
  line-height: 70px;
  margin: 10px 0;

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: 26px;
    margin-top: 32px;
    line-height: normal;
  }
`

const CenterText = styled.p`
  font-size: 24px;
  font-weight: 600;

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: 18px;
  }
`
